import { render, staticRenderFns } from "./MasterSuggestedReceivingLocationDialog.vue?vue&type=template&id=dd3cd588&scoped=true&"
import script from "./MasterSuggestedReceivingLocationDialog.vue?vue&type=script&lang=js&"
export * from "./MasterSuggestedReceivingLocationDialog.vue?vue&type=script&lang=js&"
import style0 from "./MasterSuggestedReceivingLocationDialog.vue?vue&type=style&index=0&id=dd3cd588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3cd588",
  null
  
)

export default component.exports